import React from "react";
import { Carousel } from "react-bootstrap";
import { Link } from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import "./HomeCarousel.scss";

function HomeCarousel() {
  const {t} = useTranslation()
  const map = [
    {
      id: 1,
      clas1: "for_backline1",
      class2: "slider1",
      title: t("homeCarousel.title1"),
      title2: t("homeCarousel.subTitle1"),
    },
    {
      id: 2,
      clas1: "for_backline2",
      class2: "slider2",
      title: t("homeCarousel.title2"),
      title2: t("homeCarousel.subTitle2"),
    },
    {
      id: 3,
      clas1: "for_backline3",
      class2: "slider3",
      title: t("homeCarousel.title3"),
      title2: t("homeCarousel.subTitle3"),
    },
  ];
  const map2 = map.map((a) => (
    <Carousel.Item key={a.id}>
      <div className={a.clas1}>
        <div className={a.class2}>
          <div className="sometext">
            <h1>{a.title}</h1>
            <h4>{a.title2}</h4>
            <Link className="to_other_page" to="/teacher">{t("seeMore")}</Link>
          </div>
        </div>
      </div>
    </Carousel.Item>
  ));
  return (
    <div className="HomeCarousel">
      <Carousel fade>{map2}</Carousel>
    </div>
  );
}

export default HomeCarousel;
